import React from "react";
import { Input } from "reactstrap";
import { useSpecificationContextState } from "./useSpecificationContextState";
import { useSpecificationContextUpdater } from "./useSpecificationContextUpdater";

export default function RadioInputWrapper({
  onChangeString,
  readOnlyPRP,
  yarnUOFM = false,
  firstTwist = false,
  secondTwist = false,
}) {
  const SpecContextState = useSpecificationContextState();
  const SpecContextUpdater = useSpecificationContextUpdater();

  let value = SpecContextState.specification[onChangeString];
  const readOnly = (readOnlyPRP === null || readOnlyPRP === undefined) ? false : !readOnlyPRP;

  if (yarnUOFM) {
    return (
      <>
        <Input
          type="radio"
          name="yarnUOFM"
          className="me-1 "
          checked={value === "Denier"}
          onChange={() => SpecContextUpdater.onChange("yarnSizeUnitOfMeasure", "Denier")}
        />
        <h5 style={{ textAlign: "left", marginTop: "10px", color: "white" }}>
          Denier
        </h5>
        <Input
          type="radio"
          name="yarnUOFM"
          className="ms-4 me-1 radio-color"
          checked={value === "Cotton Count"}
          onChange={() => SpecContextUpdater.onChange("yarnSizeUnitOfMeasure", "Cotton Count")}
        />
        <h5 style={{ textAlign: "left", marginTop: "10px", color: "white" }}>
          Cotton Count
        </h5>
      </>
    );
  } else if (firstTwist) {
    return (
      <>
        <Input
          type="radio"
          name="firstTwist"
          className="me-1 radio-color "
          checked={value === "Z"}
          onChange={() => SpecContextUpdater.onChange("firstTwistDirection", "Z")}
          disabled={readOnly}
        />
        <h5 style={{ textAlign: "left", marginTop: "10px", color: "white" }}>
          Z
        </h5>
        <Input
          type="radio"
          name="firstTwist"
          className="ms-4 me-1 radio-color"
          checked={value === "S"}
          onChange={() => SpecContextUpdater.onChange("firstTwistDirection", "S")}
          disabled={readOnly}
        />
        <h5 style={{ textAlign: "left", marginTop: "10px", color: "white" }}>
          S
        </h5>
        <Input
          type="radio"
          name="firstTwist"
          className="ms-4 me-1 radio-color"
          checked={value === "Flat"}
          onChange={() => SpecContextUpdater.onChange("firstTwistDirection", "Flat")}
          disabled={readOnly}
        />
        <h5 style={{ textAlign: "left", marginTop: "10px", color: "white" }}>
          Flat
        </h5>
      </>
    );
  } else if (secondTwist) {
    return (
      <>
        <Input
          type="radio"
          name="secondTwist"
          className="me-1 radio-color"
          checked={value === "Z"}
          onChange={() => SpecContextUpdater.onChange("secondTwistDirection", "Z")}
          disabled={readOnly}
        />
        <h5 style={{ textAlign: "left", marginTop: "10px", color: "white" }}>
          Z
        </h5>
        <Input
          type="radio"
          name="secondTwist"
          className="ms-4 me-1 radio-color"
          checked={value === "S"}
          onChange={() => SpecContextUpdater.onChange("secondTwistDirection", "S")}
          disabled={readOnly}
        />
        <h5 style={{ textAlign: "left", marginTop: "10px", color: "white" }}>
          S
        </h5>
      </>
    );
  } else {
    return null;
  }
}
